import { configureStore } from '@reduxjs/toolkit';
import enthusiasmReducer from './reducers'; // Ensure this file exists

// Create the store
const store = configureStore({
  reducer: {
    enthusiasm: enthusiasmReducer,
  },
});

// Export the store type for use in components
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
